import { FC, useEffect, useState } from "react";
import { Guid } from "../../../api/baseApi";
import { CenterModal } from "../sideModal/Modal";
import FileInfo from "../fileInfo/FileInfo";
import { getMediaById, getMediaCategories, MediaContentType, MediaModel, MediaType, updateMedia } from "../../../api/mediaApi";

type Option<T> = { value: T, label: string }

interface MediaPreviewModalProps {
    mediaId: Guid,
    show: boolean,
    onRequestClose: () => void,
    onUpdated: () => void,
    mode?: 'readonly' | 'edit'
}

const MediaPreviewModal: FC<MediaPreviewModalProps> = ({ mediaId, show, onRequestClose, onUpdated, mode = 'edit' }) => {

    let [mediaInfo, setMediaInfo] = useState<MediaModel | null>(null);
    let [mediaCategories, setMediaCategories] = useState<Option<number>[]>([]);
    let [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            let [mediaResult, categoriesResult] = await Promise.all([
                getMediaById(mediaId),
                getMediaCategories()
            ]);

            if (mediaResult.type === "succes") {
                setMediaInfo(mediaResult.data.data);
            }
            if (categoriesResult.type === "succes") {
                setMediaCategories(categoriesResult.data.items.map(it => ({ value: it.id, label: it.name })));
            }
            setIsLoading(false);
        }

        if (show && mediaId) {
            fetchData();
        }
    }, [show, mediaId]);

    const closeModal = () => {
        let video = document.querySelector('video');
        video?.pause();
        if (video) video.currentTime = 0;
        setMediaInfo(null);
        onRequestClose();
    };

    const onUpdateMediaInfo = async (
        id: string,
        newName: string,
        newDuration: number,
        mediaType: MediaType,
        contentType: MediaContentType | null,
        clockID: string,
        mediaCategoryId: number | null
    ) => {
        setIsLoading(true);
        mediaType === MediaType.Image
            ? await updateMedia(id, { newName, newDurationMs: newDuration, contentType, clockID, taxonomiesCategoryId: mediaCategoryId })
            : await updateMedia(id, { newName, contentType, clockID, taxonomiesCategoryId: mediaCategoryId });
        setIsLoading(false);
        onUpdated();
        closeModal();
    };

    return (
        <CenterModal title="Media info" show={show} onRequestClose={closeModal}>
            {mediaInfo ? <FileInfo
                mode={mode}
                mediaInfo={mediaInfo}
                mediaCategories={mediaCategories}
                onUpdateMediaInfo={onUpdateMediaInfo}
            /> :
                <h1>{isLoading ? "Loading..." : "Media info is undefined"}</h1>
            }
        </CenterModal>
    );
};

export default MediaPreviewModal;
